export enum ButtonVariant {
	Primary = "Primary",
	Outlined = "Outlined",
	Text = "Text",
}
